export const SET_SERVER_DATA_ACTION = 'SET_SERVER_DATA';
export const SEND_API_REQUEST_ACTION = 'SEND_API_REQUEST';
export const RECEIVE_API_RESPONSE_ACTION = 'RECEIVE_API_RESPONSE';
